// extracted by mini-css-extract-plugin
export default {"container":"T02_email_container__tzSoQ","limiter":"T02_email_limiter__EmsXP"};